import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=852fb654&"
import script from "./intro.vue?vue&type=script&lang=js&"
export * from "./intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852fb654')) {
      api.createRecord('852fb654', component.options)
    } else {
      api.reload('852fb654', component.options)
    }
    module.hot.accept("./intro.vue?vue&type=template&id=852fb654&", function () {
      api.rerender('852fb654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/intro.vue"
export default component.exports